import { Component, OnInit, Input } from '@angular/core';

import { AlertService } from '@core/services';

export interface MessageObj {
  message: any;
  component: any;
}

@Component({
    moduleId: module.id,
    selector: 'app-alert',
    styleUrls: ['./alert-message.component.less'],
    templateUrl: './alert-message.component.html',
})
export class AlertMessageComponent implements OnInit {
  @Input() alertService: AlertService;
  @Input() parentComponent: Component;

  public message: any;
  ngOnInit() {
    this.alertService.getMessage().subscribe(message => { this.message = message; });
  }
}
